export enum PostRegistrationStep {
    SET_USERNAME = "SET_USERNAME",
    CELEBRATE = "CELEBRATE",
    COMPLETE = "COMPLETE"
}
  